import { render } from "./StockTransfer.vue?vue&type=template&id=e83158ea&scoped=true"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"

import "./StockTransfer.vue?vue&type=style&index=0&id=e83158ea&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83158ea"]])

export default __exports__